import { Component } from '@angular/core';

@Component({
    selector: 'scitis-webgl-page-actions',
    templateUrl: './webgl-page-actions.component.html',
    styleUrls: ['./webgl-page-actions.component.scss'],
    standalone: false
})
export class WebglPageActionsComponent {

  constructor() { }



  onOpenWebGLSettingsModal() {

  }
}
